import { Cart, ResponseError } from '@ynap/api-utils'
import { raygun } from '@ynap/clientside-monitoring'
import { timeout, delay } from '@ynap/promise-utils'
import { redirectToLogin } from '@ynap/redirect-utils'
import { FETCH_CART_REQUEST, FETCH_CART_SUCCESS, FETCH_CART_ERROR } from '../constants/ActionTypes'

const fetchCartRequest = () => ({
    type: FETCH_CART_REQUEST,
})

const fetchCartSuccess = (payload) => ({
    type: FETCH_CART_SUCCESS,
    payload,
})

const fetchCartError = (error) => ({
    type: FETCH_CART_ERROR,
    error,
})

export default function fetchCart() {
    return (dispatch, getState, fetch) => {
        const { locale, config = {}, uberToken } = getState()
        const { country } = locale
        const { clientRequest } = config.head || config
        const { baseUrl, clientId } = config.global.services.commerce
        const { brandId } = config.global.application

        dispatch(fetchCartRequest())

        if (!uberToken) {
            return redirectToLogin(locale.id)
        }

        const request = Cart.getCart({
            baseUrl,
            brandId,
            country,
            uberToken,
            clientId,
            locale: locale.langISO,
        })

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                const { ok, status } = res
                if (ok) {
                    return res.json().then((json) => {
                        const buyerId = json?.x_buyerId
                        if (buyerId) {
                            raygun.helpers.agent('setUser', { identifier: buyerId })
                        }
                        return dispatch(fetchCartSuccess(json))
                    })
                } else if (status === 401 || status === 403) {
                    return redirectToLogin(locale.id)
                }
                throw new ResponseError(res)
            })
            .catch((error) => {
                dispatch(fetchCartError(error.message || error))
                throw error
            })
    }
}
